/**
 * CMS-Inhalte nutzen teils <strong><p>…</p></strong> statt <p><strong>…</strong></p>.
 * Browser korrigieren das nicht zuverlässig – wir normalisieren vor dem Rendern.
 */
export function normalizeInvertedStrongParagraphs(html) {
  if (!html || typeof html !== 'string') return html || ''

  if (typeof document === 'undefined') {
    return html.replace(
      /<strong(\s[^>]*)?>\s*<p(\s[^>]*)?>([\s\S]*?)<\/p>\s*<\/strong>/gi,
      '<p$2><strong$1>$3</strong></p>'
    )
  }

  const template = document.createElement('div')
  template.innerHTML = html

  template.querySelectorAll('strong').forEach((strong) => {
    const paragraph = strong.querySelector(':scope > p')
    if (!paragraph || paragraph.parentElement !== strong) return

    const normalizedParagraph = document.createElement('p')
    Array.from(paragraph.attributes).forEach(({ name, value }) => {
      normalizedParagraph.setAttribute(name, value)
    })

    const normalizedStrong = document.createElement('strong')
    Array.from(strong.attributes).forEach(({ name, value }) => {
      normalizedStrong.setAttribute(name, value)
    })
    normalizedStrong.innerHTML = paragraph.innerHTML

    normalizedParagraph.appendChild(normalizedStrong)
    strong.replaceWith(normalizedParagraph)
  })

  return template.innerHTML
}
